import { mapActions } from 'vuex';
import { KEYS } from '@/utils/constants';
export default {
    name: 'Signup',
    data: () => ({
        email: '',
        show: false,
        valid: false,
        checkbox: false,
        message: '',
        colorAlert: 'red',
        password: '',
        passwordConfirmation: '',
        emailRules: {
            name: 'Email',
            type: 'email',
            required: true,
            valid: true
        },
        passwordRules: {
            name: 'Senha',
            type: 'password',
            required: true,
            length: 8,
            valid: true
        },
        loading: false,
        isMobile: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    methods: {
        ...mapActions('user', ['registerUser']),
        openWindow(name) {
            const routeData = this.$router.resolve({
                name
            });
            window.open(routeData.href, '_blank');
        },
        async signup() {
            this.loading = true;
            if (!this.$cookies.get(KEYS.ACCEPETD_COOKIES)) {
                this.message = 'Para cadastrar no sistema, é nescessário aceitar os cookies primeiro';
                this.colorAlert = 'red';
                this.show = true;
                return this.loading = false;
            }
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            if (this.formValid) {
                if (this.password != this.passwordConfirmation) {
                    this.loading = false;
                    return this.alert('Por favor, forneça o mesmo valor de senha', 'red');
                }
                if (!this.checkbox) {
                    this.loading = false;
                    return this.alert('Por favor, aceite os termos de uso', 'red');
                }
                const formData = await this.makePostData();
                this.$gtag.event('Basico', {
                    event_category: 'Cadastro'
                });
                const { error } = await this.registerUser({ formData });
                if (error) {
                    this.loading = false;
                    this.alert(error, 'red');
                } else {
                    this.$router.push('/inicio');
                }
            }
            this.loading = false;
        },
        async makePostData() {
            return {
                email: this.email.toLowerCase(),
                password1: this.password,
                password2: this.passwordConfirmation
            };
        },
        alert(message, color) {
            this.message = message;
            this.colorAlert = color;
            this.show = true;
        }
    },
    computed: {
        btnColor() {
            return this.formValid ? 'blue' : 'green';
        },
        formValid() {
            return this.emailRules.valid && this.passwordRules.valid ? true : false;
        }
    }
};
